import { PayCorrectionEmployeeItem } from 'apps/sigma2-ui/src/pay-correction/components/PayCorrectionTable';

export const isPayCorrectionEmployeeNeedsAttention = ({
  item,
}: {
  item: PayCorrectionEmployeeItem;
}) => {
  return item.underpaid > 0;
};
